export const URL_GET_NOTIFICATIONS_ALL_DATA = '/notifications/all-data';
export const URL_MARK_NOTIFICATIONS_READ = '/notifications/mark-all-read';
export const URL_UPDATE_NOTIFICATION_STATUS = '/notifications/update/:id';
export const URL_DELETE_NOTIFICATION = '/notifications/delete/:id';
